<template>
  <div id="login-container">
    <div class="form-area">
      <div class="logo-area p-20">
        <img class="auth_logo" :src="logoNew"  alt="logo_img"/>
      </div>
      <form v-if="!twoFactorRequired" id="login_form" novalidate class="md-layout md-alignment-center-center "
            @submit.prevent="">
        <md-card class="mt-minus-25 md-layout-item bg_w rounded p-20">
          <md-card-header class="pt-0">
            <h3 class="center bold mb-0">Login</h3>
            <p class="center">Bitte melden Sie sich mit Ihren Zugangsdaten an.</p>
          </md-card-header>

          <md-card-content class="pt-30">
            <md-field class="md-focused">
              <label :class="{ active: form.username}" for="username">Email-Adresse<span
                  class="md-required">*</span></label>
              <md-input type="new_email" placeholder="Email-Adresse" name="username" id="username" autocomplete="email"
                        v-model="form.username"
                        :disabled="sending"/>
            </md-field>
            <p class="pt-30">
              <md-field class="md-focused">
                <label :class="{ active: form.password}" for="password">Passwort<span class="md-required">*</span></label>
                <md-input v-model="form.password" name="password" placeholder="Passwort" id="password"
                          type="password"></md-input>
              </md-field>
            </p>
            <p class="center pt-15">
              <router-link to="/passwordhelp" custom v-slot="{ navigate }" class="link center"  style="cursor: pointer;">
                <span @click="navigate" @enter="navigate" role="link">Passwort vergessen?</span>
              </router-link>
            </p>
          </md-card-content>

          <md-progress-bar md-mode="indeterminate" v-if="sending"/>

          <md-card-actions class="justify-center pb-10">
            <md-button class="md-raised md-primary" type="submit" @click="signIn" :disabled="sending">Login</md-button>
          </md-card-actions>
          <span class="signin-version">v{{ version }}</span>
        </md-card>
      </form>

      <form v-if="twoFactorRequired" class="md-layout md-alignment-center-center" @submit.prevent="">
        <md-card class="mt-minus-25 md-layout-item bg_w rounded p-20">
          <md-card-header class="pt-0">
            <h3 class="center bold mb-0">{{ options.Lang['2fa_login_title'] }}</h3>
            <p class="center" v-if="!useRecoveryCode">{{ options.Lang['2fa_login_totp_prompt'] }}</p>
            <p class="center" v-if="useRecoveryCode">{{ options.Lang['2fa_login_recovery_prompt'] }}</p>
          </md-card-header>

          <md-card-content class="pt-30">
            <md-field class="md-focused" v-if="!useRecoveryCode">
              <label for="totpCode">{{ options.Lang['2fa_login_totp_label'] }}</label>
              <md-input type="text" maxlength="6" placeholder="000000" name="totpCode" id="totpCode"
                        v-model="totpCode" @keyup.enter="verifyTotp" :disabled="sending" autocomplete="one-time-code"/>
            </md-field>
            <md-field class="md-focused" v-if="useRecoveryCode">
              <label for="recoveryCode">{{ options.Lang['2fa_login_recovery_label'] }}</label>
              <md-input type="text" maxlength="8" placeholder="A1B2C3D4" name="recoveryCode" id="recoveryCode"
                        v-model="totpCode" @keyup.enter="verifyTotp" :disabled="sending"/>
            </md-field>
            <p v-if="twoFactorError" class="center pt-15" style="color: red;">{{ twoFactorErrorMsg }}</p>
            <p class="center pt-15" style="cursor: pointer;">
              <span @click="useRecoveryCode = !useRecoveryCode; totpCode = '';">
                {{ useRecoveryCode ? options.Lang['2fa_login_use_totp'] : options.Lang['2fa_login_use_recovery'] }}
              </span>
            </p>
            <div class="center pt-15">
              <md-checkbox v-model="trustDevice" class="md-primary">
                {{ options.Lang['2fa_trust_device'] }}
              </md-checkbox>
            </div>
          </md-card-content>

          <md-progress-bar md-mode="indeterminate" v-if="sending"/>

          <md-card-actions class="justify-center pb-20">
            <md-button class="md-raised secondary" @click="cancelTwoFactor" :disabled="sending">{{ options.Lang['2fa_cancel'] }}</md-button>
            <md-button class="md-raised md-primary" @click="verifyTotp" :disabled="sending">{{ options.Lang['2fa_confirm'] }}</md-button>
          </md-card-actions>
        </md-card>
      </form>

      <Error class="errorDialog" v-if="options.showError" :options="options"></Error>
    </div>
  </div>
</template>

<script>
import AuthService from "../../services/AuthService";
import Error from "../../components/dialogs/Error.vue";
import {validationMixin} from 'vuelidate'

import {
  required
} from 'vuelidate/lib/validators'

export default {
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  mixins: [validationMixin],
  components: {Error},
  data() {
    return {
      logoNew: null,
      logoBack: null,
      version: process.env.VUE_APP_VERSION,
      form: {
        username: null,
        password: null,
      },
      validations: {
        form: {
          username: {
            required
          },
          password: {
            required,
          }
        }
      },
      sending: false,
      twoFactorRequired: false,
      tempToken: null,
      twoFactorUsername: null,
      totpCode: '',
      useRecoveryCode: false,
      twoFactorError: false,
      twoFactorErrorMsg: '',
      trustDevice: false
    };
  },
  async mounted() {
    this.$route.params.forwarding_msg === '' ? this.title = this.$route.params.forwarding_msg : '';
    this.options.isUploading = false;
    let self = this;
    await this.doPost({}, 'getglobalinfo', function (res) {
      if (res.data.status === 'error') {
        self.help.log(self.$t(res.msg), false, true);
      } else {
        let result = res.data.data[0];
        self.logoNew = result.baseLogo;
      }
    });
    await this.doPost({}, 'getglobalinfo', function (res) {
      if (res.data.status === 'error') {
        self.help.log(self.$t(res.msg), false, true);
      } else {
        let result = res.data.data[0];
        self.logoBack = process.env.VUE_APP_CRM_URL + "/titleImgs/file." + result.logoback
        document.getElementById("login-container").style.cssText = `background-image: url(${self.logoBack})`;
      }
    });
  },
  created() {
  },
  beforeRouteLeave(req, res, next) {
    next();
  },

  beforeMount() {
    if (this.options.user.loggedIn === true) {
      this.$router.push("/trips");
    }
  },
  methods: {
    doCompleteLogin(self, responseData) {
      let user = responseData.user.result[0];
      let token = responseData.token;
      self.$store.dispatch('login', {token, user}).then(function () {
        self.options.user = {};
        self.options.user.supersuper = self.$store.getters.getUser.supersuper;
        self.options.user.seeAlert = self.$store.getters.getUser.seeAlert;
        self.options.user.username = self.$store.getters.getUser.username;
        self.options.user.id = self.$store.getters.getUser.id;
        self.options.user.firstname = self.$store.getters.getUser.firstname;
        self.options.user.lastname = self.$store.getters.getUser.lastname;
        self.options.user.pic = self.$store.getters.getUser.pic;
        self.options.user.role = self.$store.getters.getUser.role;
        self.options.user.company = self.$store.getters.getUser.company;
        self.options.user.brandings = self.$store.getters.getUser.brandings;
        self.options.user.status = self.$store.getters.getUser.status;
        self.options.user.trips_isolated = self.$store.getters.getUser.trips_isolated;
        self.options.user.token = self.$store.getters.isLoggedIn;
        self.options.dbg = (self.$route.query.dbg && parseInt(self.$route.query.dbg) === 1);
        self.options.currentRoute = false;
        self.options.user.loggedIn = true;
        self.$router.push('/trips');
      }, function (e) {
        // console.log(e)
      })
    },
    signIn() {
      let self = this;
      const storedTrustToken = localStorage.getItem('deviceTrust_' + this.form.username);
      const signInData = Object.assign({}, this.form);
      if (storedTrustToken) {
        signInData.deviceTrustToken = storedTrustToken;
      }
      AuthService.signIn({
        data: this.encodeData(signInData),
        dbg: (this.options && this.options.dbg !== false)
      }).then(response => {
            if (response !== undefined && response.data !== undefined && response.msg !== undefined && response.status === "ok") {
              let responseData = this.decodeData(response.data);

              if (responseData.requires2FA) {
                self.twoFactorRequired = true;
                self.tempToken = responseData.tempToken;
                self.twoFactorUsername = responseData.username;
                return;
              }

              if (responseData.user === undefined) {
                this.showErrorMsg(response.msg);
                return;
              }
              let user = responseData.user.result[0];
              let token = responseData.token;
              this.$store.dispatch('login', {token, user}).then(function () {
                self.options.user = {};
                self.options.user.supersuper = self.$store.getters.getUser.supersuper;
                self.options.user.seeAlert = self.$store.getters.getUser.seeAlert;
                self.options.user.username = self.$store.getters.getUser.username;
                self.options.user.id = self.$store.getters.getUser.id;
                self.options.user.firstname = self.$store.getters.getUser.firstname;
                self.options.user.lastname = self.$store.getters.getUser.lastname;
                self.options.user.pic = self.$store.getters.getUser.pic;
                self.options.user.role = self.$store.getters.getUser.role;
                self.options.user.company = self.$store.getters.getUser.company;
                self.options.user.brandings = self.$store.getters.getUser.brandings;
                self.options.user.status = self.$store.getters.getUser.status;
                self.options.user.trips_isolated = self.$store.getters.getUser.trips_isolated;
                self.options.user.token = self.$store.getters.isLoggedIn;
                self.options.dbg = (self.$route.query.dbg && parseInt(self.$route.query.dbg) === 1);
                self.options.currentRoute = false;
                self.options.user.loggedIn = true;
                self.$router.push('/trips');
              }, function (e) {
                // console.log(e)
              })
            } else {
              this.showErrorMsg(response?.msg);
              // this.options.errorMsg = options.Lang.checkInput;
            }
          }
      ).catch(e => {
        this.showErrorMsg("Falsche Eingabe. Bitte Passwort und E-Mailadresse überprüfen.")
        // this.options.errorMsg = options.Lang.checkInput;
      });
    },
    verifyTotp() {
      let self = this;
      self.sending = true;
      self.twoFactorError = false;
      AuthService.verifyTotp({
        data: this.encodeData({
          username: this.twoFactorUsername,
          totpCode: this.totpCode,
          tempToken: this.tempToken,
          isRecoveryCode: this.useRecoveryCode,
          trustDevice: this.trustDevice
        }),
        dbg: (this.options && this.options.dbg !== false)
      }).then(response => {
        self.sending = false;
        if (response && response.data && response.status === "ok") {
          let responseData = self.decodeData(response.data);
          if (responseData.token) {
            if (responseData.deviceTrustToken) {
              localStorage.setItem('deviceTrust_' + self.twoFactorUsername, responseData.deviceTrustToken);
            }
            self.doCompleteLogin(self, responseData);
          }
        } else {
          self.twoFactorError = true;
          self.twoFactorErrorMsg = response?.msg || 'Ungültiger Code';
          self.totpCode = '';
        }
      }).catch(e => {
        self.sending = false;
        self.twoFactorError = true;
        self.twoFactorErrorMsg = self.options.Lang['2fa_login_error'];
      });
    },
    cancelTwoFactor() {
      this.twoFactorRequired = false;
      this.tempToken = null;
      this.twoFactorUsername = null;
      this.totpCode = '';
      this.useRecoveryCode = false;
      this.twoFactorError = false;
      this.twoFactorErrorMsg = '';
      this.trustDevice = false;
    },
    validate() {
        this.save()
    }
  }
};
</script>

<style>
#login-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100vh;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  padding: 40px 20px;
  overflow-y: auto;
}

.form-area {
  width: 100%;
  max-width: 460px;
  min-width: 10%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.logo-area {
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
  width: 100%;
}

img.auth_logo {
  max-width: 200px;
  height: auto;
  display: block;
}

.md-card {
  width: 100% !important;
}

.md-card {
  position: relative;
}

.signin-version {
  position: absolute;
  right: 12px;
  bottom: 6px;
  font-size: 11px;
  color: #888;
  line-height: 1;
  pointer-events: none;
}
</style>